import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { reportClientError } from "../lib/report-error";
import { Button } from "../ui";

/** A screen whose code failed to load (new release, lost signal) or crashed. Says so and offers a reload. */
const CHUNK = /dynamically imported module|Importing a module script failed|Loading chunk|error loading dynamically/i;

export function RouteError() {
  const err = useRouteError();
  const chunk = err instanceof Error && CHUNK.test(err.message);
  useEffect(() => {
    if (!chunk && !isRouteErrorResponse(err)) reportClientError(err);
  }, [err, chunk]);
  const offline = typeof navigator !== "undefined" && !navigator.onLine;
  return (
    <div className="route-error" role="alert">
      <h1>This screen did not load</h1>
      <p className="muted">
        {offline ? "No signal. Reload once you're back online." : chunk ? "A new version of the app is out. Reload to get it." : "Something broke on this screen. We've been told. Reload to try again."}
      </p>
      <div className="row">
        <Button onClick={() => window.location.reload()}>Reload</Button>
        <a className="btn btn--secondary" href="/">Go to start</a>
      </div>
    </div>
  );
}
